import React, { useEffect, useState } from "react";
import Sidebar from "../../../layouts/sidebar";
import Headers from "../../../layouts/header";
import Select from "react-select";
import Datetime from "react-datetime";
import moment from "moment";
import "react-datetime/css/react-datetime.css";
import { Nav, Tab, Row, Col } from "react-bootstrap";
import { styled } from "@mui/material/styles";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import useAxiosFile from "../../../actions/useaxios";
import config from "../../../actions/config";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import Exportcsv from "./Exportcsv";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router";
import { DecryptData, EncryptData, isEmpty } from "../../../actions/common";

function CategoryContents() {
  const { toggle } = useSelector((state) => state.admin_panel.User);

  const navigate = useNavigate();

  const axiosFile = useAxiosFile();
  const { id, _id } = useParams()
  const [Datas, SetDatas] = useState([]);
  const [Search, SetSearch] = useState("");
  const [category, SetCategory] = useState("");
  const [Contents, SetContents] = useState({
    answer: "",
    question: ""
  });
  const [ValidateError, SetValidateError] = useState({});

  var { pathname } = useLocation()
  pathname = pathname.split('/')[1]
  console.log("pathname======", pathname)
  useEffect(() => {
    if (pathname == "category-contents" || pathname == "edit-category-contents") GetLocations();
  }, [Search, pathname]);

  const GetLocations = async () => {

    var resp = await axiosFile.CategoryAction({ from: 'admin', action: pathname, Search: Search, _id, id });
    console.log("dasdasdsadsa", resp);
    if (pathname == "edit-category-contents") {
      SetContents(resp.data?.[0]?.Contents?.find(it => it._id == _id))
    } else SetDatas(resp?.data[0]?.Contents);
    // SetDatas(resp?.data)
  };



  async function _delete(params, showhome) {
    let resp = await axiosFile.CategoryAction({ from: 'admin', action: 'delete-category-contents', _id: params, id });
    console.log("resp.success ", resp.success, resp?.msg);
    if (resp.success == "success") {
      toast.success(`Deleted from Documnet Successfully`);
      GetLocations();
      return
    }
    return toast.error(resp?.msg ? resp?.msg : "Something Went Wrong");

  }
  async function _add(params, showhome) {
    if (isEmpty(Contents.answer)) {
      SetValidateError({
        answer: "answer required"
      })
      toast.error("answer required");
      return false
    }
    if (isEmpty(Contents.question)) {
      SetValidateError({
        question: "question required"
      })
      toast.error("question required");
      return false
    }

    let resp = await axiosFile.CategoryAction({ _id: id, from: 'admin', action: 'add-category-contents', Contents });
    console.log("resp.success ", resp.success, resp?.msg);
    if (resp.success == "success") {
      toast.success(`Added Contents Successfully`);
      navigate(`/category-contents/${id}`)
      SetCategory("")
      // GetLocations();
      return
    }
    SetValidateError(resp.error)
    return toast.error(resp?.msg ? resp?.msg : "Something Went Wrong");

  }
  async function _edit(params, showhome) {
    if (isEmpty(Contents.answer)) {
      SetValidateError({
        answer: "answer required"
      })
      toast.error("answer required");
      return false
    }
    if (isEmpty(Contents.question)) {
      SetValidateError({
        question: "question required"
      })
      toast.error("question required");
      return false
    }
    let resp = await axiosFile.CategoryAction({ from: 'admin', action: 'edit-category-contents-action', _id, id, Contents });
    console.log("resp.success ", resp.success, resp?.msg);
    if (resp.success == "success") {
      toast.success(`Edited from Documnet Successfully`);
      navigate(`/category-contents/${id}`)
      SetCategory("")
      // GetLocations();
      return
    }
    SetValidateError(resp.error)
    return toast.error(resp?.msg ? resp?.msg : "Something Went Wrong");

  }

  console.log("++++++++++++++++++++", Contents)

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 5,
    lastPageText: ">>",
    firstPageText: "<<",
    nextPageText: ">",
    prePageText: "<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: function (page, sizePerPage) { },
    onSizePerPageChange: function (page, sizePerPage) { },
  });

  const columns = [

    {
      dataField: "question",
      text: "Question",
      sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          {console.log('cellcell', cell, row)}
          <p>{cell}</p>
        </>
      )
    }, {
      dataField: "answer",
      text: "Answer",
      sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          {console.log('cellcell', cell, row)}
          <p>{cell}</p>
        </>
      )
    },
    {
      dataField: "_id",
      text: "Edit",
      sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          <div onClick={() => navigate(`/edit-category-contents/${(id)}/${row?._id}`)}>
            <p>Edit</p></div>
        </>
      )
    },
    {
      dataField: "_id",
      text: "Delete",
      sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          <div onClick={() => _delete(cell)}>

            <p>{'Delete'}</p>
          </div>
        </>
      )
    }

  ];





  return (
    <>
      <section id="content-wrapper">
        <div class="row">
          <div className="top_title_sec">
            <div>
              <p className="page_title mb-0">Category-Contents</p>
            </div>
            {pathname == "category-contents" ?
              <div className="rightside just_end ">
                <button
                  type="button"
                  className="blue_btn add_deliveryprsn dp_btn_hover"
                  onClick={() => { navigate(`/add-category-contents/${id}`); SetContents({ answer: "", question: "" }) }}
                >
                  Add Contents
                </button>

              </div> : <></>}
            {pathname == "category-contents" ?
              <div className="rightside just_end ">
                <button
                  type="button"
                  className="blue_btn add_deliveryprsn dp_btn_hover"
                  onClick={() => { navigate(`/Categorylist`) }}
                >
                  Back
                </button>

              </div> : <></>}
          </div>
        </div>
        {
          pathname == "category-contents" ?

            <div className="row mt-4 mx-auto">
              <div className="sec_border">
                <div className="row">
                  <div className="col-xxl-4 col-xl-4 col-lg-3 col-md-3 col-sm-6 col-12">
                    <div className="whole_searchbar white_bg search_mx_ht">


                      <input placeholder="Search term" onChange={(e) => SetSearch(e.target.value)} value={Search} />
                    </div>
                  </div>


                  {Datas && (
                    <div className="ffd_table mar_bot">
                      <BootstrapTable
                        bootstrap4
                        keyField="id"
                        columns={columns}
                        data={Datas}
                        pagination={pagination}
                        noDataIndication="No Category-Contents found"
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
            :
            <div className="sec_border">
              <Row className="mdv_inputrow">
                <Col
                  xxl={6}
                  xl={6}
                  lg={6}
                  md={6}
                  sm={6}
                  xs={12}
                  className="mb-3"
                >
                  <p className="mdv_inplabel"> Question </p>
                  <input
                    className="mdv_cmninput"
                    value={Contents?.question ?? ""}
                    type="text"
                    placeholder="Enter Question"
                    onChange={(e) => SetContents({
                      ...Contents, ...{ question: e?.target?.value }
                    })}
                  />
                  {ValidateError && ValidateError?.question && (
                    <span className="error-msg">
                      {ValidateError.question}
                    </span>
                  )}
                </Col>
                <Col
                  xxl={6}
                  xl={6}
                  lg={6}
                  md={6}
                  sm={6}
                  xs={12}
                  className="mb-3"
                >
                  <p className="mdv_inplabel"> Answer</p>
                  <input
                    className="mdv_cmninput"
                    value={Contents?.answer ?? ""}
                    type="text"
                    placeholder="Enter Answer"
                    onChange={(e) => SetContents({
                      ...Contents, ...{ answer: e?.target?.value }
                    })}
                  />
                  {ValidateError && ValidateError?.answer && (
                    <span className="error-msg">
                      {ValidateError.answer}
                    </span>
                  )}
                </Col>




              </Row>
              <div className="mdv_update_dualbtn mt-3">
                <button
                  className="blue_btn mdv_update"
                  onClick={() => { pathname == "add-category-contents" ? _add() : _edit() }}
                >
                  {pathname == "add-category-contents" ? "save" : "edit"}
                </button>
              </div>
              <div>
                Notes: (keyword must be unique as given below)
                <ul>
                  <li> Declare City name as "City name" </li>
                  <li> Declare store name as "Store Name" </li>
                  <li> Declare category name as "Services" </li>
                  <li> Declare sub category name as "Subcategory" </li>
                  <li> Declare product name as "Product Name" </li>
                </ul>
              </div>
            </div>}
      </section>
    </>
  );
}

export default CategoryContents;
